<template>
  <v-container fluid class="rooms-slider-container">
    <v-row justify="center" align="center" class="fill-height">
      <v-col cols="12" md="10" class="room-wrapper">
        <transition
          name="fade-slide"
          mode="out-in"
        >
          <slot :name="currentRoomSlot" />
        </transition>
      </v-col>
    </v-row>
    <v-icon-btn
      icon="mdi-chevron-left-circle"
      class="nav-arrow left"
      @click="prevRoom"
    />
    <v-icon-btn
      icon="mdi-chevron-right-circle"
      class="nav-arrow right"
      @click="nextRoom"
    />
  </v-container>
</template>

<script setup>
import { ref, computed, defineProps } from 'vue';

const props = defineProps({
  roomSlots: { type: Array, required: true },
});

const currentRoom = ref(0);

const currentRoomSlot = computed(() => props.roomSlots[currentRoom.value]);

const nextRoom = () => {
  currentRoom.value = (currentRoom.value + 1) % props.roomSlots.length;
};

const prevRoom = () => {
  currentRoom.value = (currentRoom.value - 1 + props.roomSlots.length) % props.roomSlots.length;
};
</script>

<style scoped>
.rooms-slider-container {
  height: 100vh;
  position: relative;
}

.room-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 90vh;
}

.nav-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: hsla(0, 0%, 100%, 0);
  z-index: 10;
  font-size: 2rem;
}

.nav-arrow.left {
  left: 1rem;
}

.nav-arrow.right {
  right: 1rem;
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.5s ease;
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translateX(50px);
}

.fade-slide-enter-to {
  opacity: 1;
  transform: translateX(0);
}

.fade-slide-leave-from {
  opacity: 1;
  transform: translateX(0);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateX(-50px);
}
</style>
